{
	"ariaPhotoColorTagList": "Photo Color Tag List",
	"ariaPhotoRatingBar": "Photo Rating Bar",
	"ariaSetPhotoColorTag": "Set Photo Color Tag",
	"ariaSetPhotoFlag": "Set Photo {{name}}",
	"ariaSetPhotoRating": "Set Photo Rating {{rating}}"
}
